import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

const IdleTimeoutDialog = ({ open, countdown, onStay, onLogout }) => {
  const minutes = Math.floor(countdown / 60);
  const seconds = countdown % 60;
  const timeDisplay = minutes > 0
    ? `${minutes}:${String(seconds).padStart(2, "0")}`
    : `${seconds}s`;

  return (
    <Dialog open={open} maxWidth="xs" disableEscapeKeyDown>
      <DialogTitle>Still there?</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          You'll be signed out in{" "}
          <Typography component="span" variant="body2" fontWeight={600} color="text.primary">
            {timeDisplay}
          </Typography>{" "}
          due to inactivity.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button onClick={onLogout} color="inherit" size="small">
          Sign out
        </Button>
        <Button onClick={onStay} variant="contained" size="small" autoFocus>
          Stay signed in
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IdleTimeoutDialog;
